import "grimoirejs/register";
import "grimoirejs-math/register";
import "grimoirejs-fundamental/register";
export default () => {
};



// WEBPACK FOOTER //
// ./src/main.ts